export default "__VITE_ASSET__94b56762__"